import { FC } from 'react';
import { CustomComponentInputs } from '../filters.types';

import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

export const DateRange: FC<CustomComponentInputs> = ({ onChange, value }) => {
  // Convert value (array of ISO strings or Date objects) to dayjs for controlled RangePicker
  let dayjsValue: [dayjs.Dayjs, dayjs.Dayjs] | undefined;

  if (Array.isArray(value) && value.length === 2) {
    try {
      dayjsValue = [dayjs(value[0]), dayjs(value[1])];
    } catch {
      dayjsValue = undefined;
    }
  }

  return (
    <RangePicker
      className="w-full"
      value={dayjsValue}
      onChange={(dates) => {
        if (dates && dates[0] && dates[1]) {
          // Return ISO strings for consistency with other date fields
          const formattedDates = [dates[0].toISOString(), dates[1].toISOString()];
          onChange(formattedDates);
        } else {
          onChange(null);
        }
      }}
    />
  );
};
